import { CustomTypeRoomTitle } from "@/lib/gql/__generated__/graphql";

import { FeatureIslandMainWithBackGround } from "@/components/features/_layouts";
import { QuestionForMain } from "@/components/features/_layouts/island/main/question";

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion/accordion";
import { InputTextField } from "@/components/ui/form/fields/input-field/input-text";
import { SelectField } from "@/components/ui/form/fields/select-field";

import type { HotelSettingsHotelInfoFormModel } from "../../../../model/type";
import type { HotelSettingsHotelInfoFormModelMethodsType } from "../../../../model/usecase/use-create-form-model/methods";

type Props = {
	viewModel: HotelSettingsHotelInfoFormModel["ViewModel"];

	snsMethods: HotelSettingsHotelInfoFormModelMethodsType["snsMethods"];
	hotelSettingsHotelInfoFormModelMethods: HotelSettingsHotelInfoFormModelMethodsType["hotelSettingsHotelInfoFormModelMethods"];
};

const SNS_ACCORDION_VALUE = "hotelInfo_additional_settings_island";
const CUSTOM_ROOM_TITLE_ACCORDION_VALUE = "hotelInfo_customTypeRoomTitle";

export const HotelSettingsHotelInfoAdditionalIsland = ({
	viewModel,
	snsMethods,
	hotelSettingsHotelInfoFormModelMethods,
}: Props) => {
	const { instagramURL, twitterURL, facebookURL, threadsURL, lineURL } = viewModel;

	const snsAccordionDefaultValue =
		(twitterURL?.value ?? instagramURL?.value ?? facebookURL?.value ?? threadsURL?.value ?? lineURL?.value) ? SNS_ACCORDION_VALUE : undefined;
	const customRoomTitleAccordionDefaultValue = viewModel.customTypeRoomTitle?.value
		? CUSTOM_ROOM_TITLE_ACCORDION_VALUE
		: undefined;

	return (
		<FeatureIslandMainWithBackGround islandTitle="追加設定">
			<Accordion type="single" defaultValue={snsAccordionDefaultValue} collapsible>
				<AccordionItem value={SNS_ACCORDION_VALUE}>
					<AccordionTrigger>SNS アカウント設定</AccordionTrigger>
					<AccordionContent>
						<QuestionForMain
							required={false}
							title="SNSアカウント設定"
							guide="ホテルのSNSアカウントが登録できます"
							inputChildren={
								<div className="space-y-6 pb-8 pt-4">
									<InputTextField
										label="X（Twitter）アカウント URL"
										value={viewModel.twitterURL?.value}
										errorMessage={viewModel.twitterURL?.error}
										handleChange={snsMethods.onSetTwitterURL}
									/>
									<InputTextField
										label="Instagram アカウント URL"
										value={viewModel.instagramURL?.value}
										errorMessage={viewModel.instagramURL?.error}
										handleChange={snsMethods.onSetInstagramURL}
									/>
									<InputTextField
										label="Facebook アカウント URL"
										value={viewModel.facebookURL?.value}
										errorMessage={viewModel.facebookURL?.error}
										handleChange={snsMethods.onSetFacebookURL}
									/>
									<InputTextField
										label="Threads アカウント URL"
										value={viewModel.threadsURL?.value}
										errorMessage={viewModel.threadsURL?.error}
										handleChange={snsMethods.onSetThreadsURL}
									/>
									<InputTextField
										label="LINE アカウント URL"
										value={viewModel.lineURL?.value}
										errorMessage={viewModel.lineURL?.error}
										handleChange={snsMethods.onSetLineURL}
									/>
								</div>
							}
						/>
					</AccordionContent>
				</AccordionItem>
			</Accordion>

			<Accordion type="single" defaultValue={customRoomTitleAccordionDefaultValue} collapsible>
				<AccordionItem value={CUSTOM_ROOM_TITLE_ACCORDION_VALUE}>
					<AccordionTrigger>部屋の名称変更</AccordionTrigger>
					<AccordionContent>
						<QuestionForMain
							required={false}
							title="部屋の名称"
							guide="ここで選択した部屋の名称が予約ページやメールの文言に使用されます。"
							inputChildren={
								<SelectField
									value={viewModel.customTypeRoomTitle?.value}
									errorMessage={viewModel.customTypeRoomTitle?.error}
									options={[
										{
											id: "customTypeRoomTitle_0",
											label: "部屋（Room）",
											value: CustomTypeRoomTitle.Room,
										},
										{
											id: "customTypeRoomTitle_1",
											label: "テント（Tent）",
											value: CustomTypeRoomTitle.Tent,
										},
									]}
									handleValueChange={hotelSettingsHotelInfoFormModelMethods.onSetCustomTypeRoomTitle}
								/>
							}
						/>
					</AccordionContent>
				</AccordionItem>
			</Accordion>
		</FeatureIslandMainWithBackGround>
	);
};

HotelSettingsHotelInfoAdditionalIsland.displayName = "HotelSettingsHotelInfoAdditionalIsland";
